import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

const iconPropsByType = {
  top: {
    color: unifiedPlatformColorPalette.lightPrimary,
    icon: faArrowUp,
  },
  bottom: {
    color: unifiedPlatformColorPalette.lightError,
    icon: faArrowDown,
  },
} as const satisfies Record<PerformersLabelProps['type'], FontAwesomeIconProps>;

const labelByType = {
  top: 'Top Performers',
  bottom: 'Bottom Performers',
} as const satisfies Record<PerformersLabelProps['type'], string>;

type PerformersLabelProps = {
  type: 'top' | 'bottom';
};

export const PerformersLabel = (props: PerformersLabelProps) => {
  return (
    <Stack direction="row" spacing="0.5rem" alignItems="center">
      <FontAwesomeIcon {...iconPropsByType[props.type]} />
      <Typography>{labelByType[props.type]}</Typography>
    </Stack>
  );
};
